<template>
  <div>
    <b-card class="mb-2 shadow bg-light">
      <b-card-title title-tag="h6"
        >Factures émises par le créancier</b-card-title
      >
      <b-table
        v-if="invoices.length > 0"
        small
        id="invoicesTable"
        responsive
        striped
        hover
        :fields="invoicesFields"
        :items="invoices"
      >
        <template v-slot:cell(type)="data">
          {{ data.item.type == "facture" ? "Facture" : "Note de crédit" }}
        </template>
        <template v-slot:cell(date)="data">{{
          toDate(data.item.date)
        }}</template>
        <template v-slot:cell(echeance)="data">{{
          toDate(data.item.echeance)
        }}</template>
        <template v-slot:cell(montant)="data"
          >{{ twoDigits(data.item.montant) }} €</template
        >
        <template v-slot:cell(solde)="data"
          >{{ twoDigits(data.item.solde) }} €</template
        >
       
        <template v-slot:bottom-row>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right">
          </td>
          <td class="text-right">
            <strong>
              Total : 
              <span 
                >{{
                  invoices
                    .reduce((a, b) => a + parseFloat(b.montant), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td class="text-right">
            <strong>
              <span
                >{{
                  invoices
                    .reduce((a, b) => a + parseFloat(b.solde), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td />
        </template> 
      </b-table>
      <b-card-body v-else>
        <b-alert show>Pas de factures</b-alert>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
export default {
  name: "warrant-invoices",
  props: ["id", "createInvoice"],
  components: {},
  data() {
    return {
      loaded: false,
      invoices: [],
      invoice_id: null,
      warrant_id: null,
      invoicesFields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "numero",
          label: "Numéro",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "echeance",
          label: "Échéance",
          sortable: true,
        },

        {
          key: "reference_client",
          label: "Ref. client",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "solde",
          label: "Solde",
          class: "text-right",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          class: "text-right",
          sortable: true,
        },
        
      
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      warrants.invoices(this.$props.id).then((response) => {
        this.invoices = response.data;
        this.loaded = true;
      });
    },
    
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>